export * from "./reward-points.component";
